const UsersMainView = () => import('@/views/superadmin/users/UsersMainView')
const StudentsView = () => import('@/views/superadmin/users/StudentsView')
const TeachersView = () => import('@/views/superadmin/users/TeachersView')

export default {
  path: 'users',
  redirect: { name: 'StudentsSuperAdmin' },
  name: 'UsersMainSuperAdmin',
  component: UsersMainView,
  meta: { label: 'Пользователи' },
  children: [
    {
      path: 'students',
      name: 'StudentsSuperAdmin',
      component: StudentsView,
      meta: { label: 'Ученики' },
    },
    {
      path: 'teachers',
      name: 'TeachersSuperAdmin',
      component: TeachersView,
      meta: { label: 'Сотрудники' },
    }
  ]
}